import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  getCustomShiftNotifications,
  GetCustomShiftNotificationsResponse,
} from 'api/shifts/getCustomShiftNotifications'
import { customShiftNotificationsKey } from './keys'

type UseCustomShiftNotificationsQueryKey = ReturnType<
  typeof customShiftNotificationsKey
>

type UseCustomShiftNotificationsQueryOptions = Partial<
  UseQueryOptions<
    GetCustomShiftNotificationsResponse,
    Error,
    GetCustomShiftNotificationsResponse,
    UseCustomShiftNotificationsQueryKey
  >
>

export function useCustomShiftNotificationsQuery(
  shiftId: number,
  options: UseCustomShiftNotificationsQueryOptions = {}
) {
  return useQuery({
    ...options,
    queryKey: customShiftNotificationsKey(shiftId),
    queryFn: () => getCustomShiftNotifications(shiftId),
  })
}
